import React from 'react';

import { TextHeader2 } from 'uiToolkitV1/Typography';

import { HeaderMarginContainer } from './HeaderMarginContainer';

export const PlainTextHeader = ({ children, ...props }) => (
  <HeaderMarginContainer>
    <TextHeader2 bold py={2} {...props}>
      {children}
    </TextHeader2>
  </HeaderMarginContainer>
);
